import React from 'react'
import Grid from '@mui/joy/Grid'
import Stamp from './Stamp'
import { useGetStoreDataQuery } from '../services/branding'

const Stamps = () => {
  const { data: storeData } = useGetStoreDataQuery()

  const numberOfStamps = storeData?.numberOfStamps ?? 0

  return (
    <Grid container xs={12} spacing={2} sx={{ textAlign: 'center' }}>
      {[...Array(numberOfStamps + 3)].map((_, index) => (
        <Stamp key={index} gridKey={index} index={index} />
      ))}
    </Grid>
  )
}

export default Stamps
